"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const material_1 = require("@mui/material");
const Close_1 = __importDefault(require("@mui/icons-material/Close"));
const KioskWrapper = styled_components_1.default.div `
  border-bottom: solid 1px
    ${(props) => props.theme.palette ? props.theme.palette.primary.main : "#fff"};
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 1104;
  height: 56px;
  background-color: white;
  padding: 0 20px;
  display: flex;
  align-items: center;

  @media (min-width: 600px) {
    height: 64px;
  }
`;
const KioskAppHeader = (props) => {
    const { title, navAction } = props;
    return (react_1.default.createElement(react_1.Fragment, null,
        react_1.default.createElement(KioskWrapper, null,
            react_1.default.createElement(material_1.IconButton, { size: "large", edge: "start", className: "back-button", "aria-label": "back button", onClick: () => navAction() },
                react_1.default.createElement(Close_1.default, null)),
            title),
        react_1.default.createElement(material_1.Toolbar, null)));
};
exports.default = KioskAppHeader;
